(function () {
    angular.module('app')
        .controller('RelatedContentController', RelatedContentController);

    RelatedContentController.$inject = ['$scope', '$attrs'];
    function RelatedContentController($scope, $attrs) {
        var ctrl = this;
        ctrl.cta = $attrs.cta;
    }
})();